import { gql } from '@apollo/client';

export const GET_HOTEL_BY_SUBDOMAIN_QUERY = gql`
  query GetHotelBySubdomain($subdomain: String!) {
    hotels(where: { subdomain: $subdomain }) {
      id
      locationLat
      locationLon
      enabledIncomingNotificationChannels
      enabledOutgoingNotificationChannels
      name
      pricingPlan {
        id
        tvAppEnabled
      }
      logo {
        id
        url
      }
      tvAppConfigurations(limit: 1, sort: "id:asc") {
        id
        slug
      }
    }
  }
`;
